import {createBrowserRouter, createRoutesFromElements, Route} from 'react-router-dom'
import {PublicRoute} from '@route-guards/public-route/PublicRoute.tsx'
import {PublicLayout} from '@layouts/public-layout/PublicLayout.tsx'
import {routes} from '@utilities/constants/routes.tsx'

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<PublicRoute />}>
            <Route element={<PublicLayout />}>
                <Route path={routes.MEASURES.path}>
                    <Route index element={routes.MEASURES.element} />
                    <Route {...routes.MEASURE_DETAILS} />
                    <Route {...routes.MEASURE_RESULTS} />
                </Route>
            </Route>
            <Route {...routes.MEASURE_RAW} />
        </Route>
    )
)
